export default __webpack_public_path__ + "static/media/cocreation.9d8cceff.svg";